const URL_IN_TEXT = /https?:\/\/[^\s<>"')]+/gi;

export const extractUrls = (text) => {
  if (!text) return [];
  const matches = String(text).match(URL_IN_TEXT) || [];
  return Array.from(new Set(matches.map((u) => u.replace(/[.,;:!?)]+$/, ''))));
};

export const normalizeUrl = (value) => extractUrls(value)[0] || '';

const BRD_LINE = /^(?:-\s*)?BRD(?:\s*Link)?\s*:?\s*(.*)$/i;
const FIGMA_LINE = /^(?:-\s*)?Figma(?:\s*Link)?\s*:?\s*(.*)$/i;
const BRD_LABEL_ONLY = /^(?:-\s*)?BRD(?:\s*Link)?\s*:?\s*$/i;
const FIGMA_LABEL_ONLY = /^(?:-\s*)?Figma(?:\s*Link)?\s*:?\s*$/i;

const urlFromTail = (tail) => normalizeUrl(tail);

const stripOrphanLinkLabels = (text) =>
  String(text || '')
    .replace(/\b(?:BRD|Figma)(?:\s*Link)?\b/gi, ' ')
    .replace(/\s{2,}/g, ' ')
    .trim();

export const parseSprintGoal = (goalText) => {
  const text = (goalText || '').trim();
  if (!text) return { goal: '', brdLink: '', figmaLink: '' };

  const lines = text.split('\n');
  const cleanLines = [];
  let brdLink = '';
  let figmaLink = '';

  for (let i = 0; i < lines.length; i += 1) {
    const rawLine = lines[i];
    const line = rawLine.trim();
    if (!line) {
      cleanLines.push(rawLine);
      continue;
    }

    if (/^reference\s+links:?$/i.test(line)) {
      continue;
    }

    const brdMatch = line.match(BRD_LINE);
    if (brdMatch) {
      const url = urlFromTail(brdMatch[1]);
      if (url) {
        brdLink = url;
        continue;
      }
      if (BRD_LABEL_ONLY.test(line)) {
        const nextLine = (lines[i + 1] || '').trim();
        const nextUrl = urlFromTail(nextLine);
        if (nextUrl) {
          brdLink = nextUrl;
          i += 1;
        }
        continue;
      }
    }

    const figmaMatch = line.match(FIGMA_LINE);
    if (figmaMatch) {
      const url = urlFromTail(figmaMatch[1]);
      if (url) {
        figmaLink = url;
        continue;
      }
      if (FIGMA_LABEL_ONLY.test(line)) {
        const nextLine = (lines[i + 1] || '').trim();
        const nextUrl = urlFromTail(nextLine);
        if (nextUrl) {
          figmaLink = nextUrl;
          i += 1;
        }
        continue;
      }
    }

    if (BRD_LABEL_ONLY.test(line) || FIGMA_LABEL_ONLY.test(line)) {
      continue;
    }

    const bareUrls = extractUrls(line);
    if (bareUrls.length === 1 && line === bareUrls[0]) {
      const lower = bareUrls[0].toLowerCase();
      if (!figmaLink && lower.includes('figma.com')) {
        figmaLink = bareUrls[0];
        continue;
      }
      if (!brdLink) {
        brdLink = bareUrls[0];
        continue;
      }
    }

    cleanLines.push(rawLine);
  }

  let goal = cleanLines.join('\n').replace(/\n{3,}/g, '\n\n').trim();
  goal = stripOrphanLinkLabels(goal);

  return { goal, brdLink, figmaLink };
};

export const composeSprintGoal = (goal, brdLink, figmaLink) => {
  const cleanGoal = (goal || '').trim();
  const refs = [];
  const brd = normalizeUrl(brdLink);
  const figma = normalizeUrl(figmaLink);
  if (brd) refs.push(`- BRD Link: ${brd}`);
  if (figma) refs.push(`- Figma Link: ${figma}`);

  if (!refs.length) return cleanGoal;
  return `${cleanGoal}\n\nReference Links:\n${refs.join('\n')}`.trim();
};
